const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkolaBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "theChar",
    "data-name": "skola",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 324.57 351.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "a4751834-f881-455f-a8c6-37d9c2613e71",
    "data-name": "border",
    d: "M22.17,25.19l104.11-.53,5.18-4.2-1.22-4,9.52-6.26s20.23,6,20.31,2.17S168.19.25,168.19.25h10.28l-5.25,7.82s10.92-3.72,15.63,0,7,16.22,7,16.22H308.82l15.4,47H312.75v212.9H277.28v14.4s-55.72-.05-60.46.33,0,44,0,48.18-25.1,4.38-27,3.43-3.34-22.73-3.07-29.87-10.21-2.34-22-3.75-2.88,21.31-9.65,22.25-63.79.48-67.11-1.27,1.42-15.78,3.68-21.47-3-17.83-3-17.83H58.32v-13.7H13.17V69.23H.39l19.89-44Z",
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkolaBorder);
export default __webpack_public_path__ + "static/media/skola-border.99195f02fcc97ae1faa23d71ac1c8eea.svg";
export { ForwardRef as ReactComponent };